import { includes } from "lodash";

const numericType = ["number", "integer", "float", "average", "percentage"];

const isNumericType = (type) => includes(numericType, type);

export { isNumericType };
